import { useEffect, useState } from "react";
import { Col, Input, Row } from "antd";
import "./createUserStep.styles.scss";
import Permissions from "../../../user/permission/permission.component";

const CreateUserStep = ({
  permissions: incomingPermissions,
  newUserProfile,
  setNewUserProfile,
  validationErrors = {},
}) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (incomingPermissions?.length > 0) {
      setPermissions(incomingPermissions);
      setLoading(false);
    }
  }, [incomingPermissions]);

  const handleChange = (field, value) => {
    setNewUserProfile((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handlePermissionChange = (index, isGranted) => {
    setPermissions((prev) =>
      prev.map((perm, i) =>
        i === index ? { ...perm, isGranted } : { ...perm }
      )
    );

    setNewUserProfile((prev) => ({
      ...prev,
      permissions: permissions.map((perm, i) =>
        i === index ? { ...perm, isGranted } : perm
      ),
    }));
  };

  return (
    <div>
      <h1>Create a User</h1>
      <div className="createUserGridContainer">
        <section className="createUserGirdItem">
          <h2 className="cardHeading">Details</h2>
          <div className="createUserGridItemContentContainer">
            <div className="create__user__form__container">
              <Row gutter={16}>
                <Col span={12}>
                  <label className="ant-form-item-label">First Name</label>
                  <Input
                    value={newUserProfile?.firstName || ""}
                    onChange={(e) => handleChange("firstName", e.target.value)}
                  />
                  {validationErrors.firstName && (
                    <p className="error">{validationErrors.firstName}</p>
                  )}
                </Col>
                <Col span={12}>
                  <label className="ant-form-item-label">Last Name</label>
                  <Input
                    value={newUserProfile?.lastName || ""}
                    onChange={(e) => handleChange("lastName", e.target.value)}
                  />
                  {validationErrors.lastName && (
                    <p className="error">{validationErrors.lastName}</p>
                  )}
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <label className="ant-form-item-label">User Name</label>
                  <Input
                    value={newUserProfile?.username || ""}
                    onChange={(e) => handleChange("username", e.target.value)}
                  />
                  {validationErrors.username && (
                    <p className="error">{validationErrors.username}</p>
                  )}
                </Col>
                <Col span={12}>
                  <label className="ant-form-item-label">Email</label>
                  <Input
                    value={newUserProfile?.email || ""}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                  {validationErrors.email && (
                    <p className="error">{validationErrors.email}</p>
                  )}
                </Col>
              </Row>

              <Row>
                <label className="ant-form-item-label">
                  Temporary Password
                </label>
                <Input.Password
                  value={newUserProfile?.password || ""}
                  onChange={(e) => handleChange("password", e.target.value)}
                />
                {validationErrors.password && (
                  <p className="error">{validationErrors.password}</p>
                )}
              </Row>
            </div>
          </div>
        </section>

        <section className="createUserGirdItem">
          <h2 className="cardHeading">Permissions</h2>
          <div className="createUserGridItemContentContainer">
            {loading ? (
              <p>Loading permissions...</p>
            ) : (
              <Permissions
                permissions={permissions}
                onChange={handlePermissionChange}
              />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default CreateUserStep;
